import { render, staticRenderFns } from "./StaffManageSettingsView.vue?vue&type=template&id=44a137aa&scoped=true"
import script from "./StaffManageSettingsView.vue?vue&type=script&lang=js"
export * from "./StaffManageSettingsView.vue?vue&type=script&lang=js"
import style0 from "./StaffManageSettingsView.vue?vue&type=style&index=0&id=44a137aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a137aa",
  null
  
)

export default component.exports